import React, { useRef } from 'react';
import { paymentMethodType } from '../../constants/accountPanelConfigs';

export const PaymentTypeSelector = ({ paymentType, setPaymentType }: any) => {
  const currentPaymentType = useRef(paymentType);

  const onChange = (value: string) => {
    if (currentPaymentType.current !== value) {
      setPaymentType(value);
      currentPaymentType.current = value;
    }
  };

  return (
    <>
      <div className="paymentMethodTypeTitle">
        <h5>Payment Method</h5>
      </div>
      <div className="paymentMethodTypeCol">
        <div
          className="existingCardCheckbox achRadioBtn"
          onClick={() => onChange(paymentMethodType.ach)}
        >
          <input
            type="radio"
            value={paymentMethodType.ach}
            checked={paymentType === paymentMethodType.ach}
          />
          <span className="radio-label">ACH</span>
        </div>
        <div
          className="existingCardCheckbox achRadioBtn"
          onClick={() => onChange(paymentMethodType.creditCard)}
        >
          <input
            type="radio"
            value={paymentMethodType.creditCard}
            checked={paymentType === paymentMethodType.creditCard}
          />
          <span className="radio-label">Credit Card</span>
        </div>
      </div>
    </>
  );
};
